import { render } from "./GeneralErrorPage.vue?vue&type=template&id=f1623d2e&scoped=true"
import script from "./GeneralErrorPage.vue?vue&type=script&lang=js"
export * from "./GeneralErrorPage.vue?vue&type=script&lang=js"

import "./GeneralErrorPage.vue?vue&type=style&index=0&id=f1623d2e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1623d2e"],['__file',"src/views/GeneralErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1623d2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1623d2e', __exports__)) {
    console.log('reload')
    api.reload('f1623d2e', __exports__)
  }
  
  module.hot.accept("./GeneralErrorPage.vue?vue&type=template&id=f1623d2e&scoped=true", () => {
    console.log('re-render')
    api.rerender('f1623d2e', render)
  })

}


export default __exports__